export const enum RetrievalMode {
    Hybrid = "hybrid",
    Vectors = "vectors",
    Text = "text"
}

export const enum GPT4VInput {
    TextAndImages = "textAndImages",
    Images = "images",
    Texts = "texts"
}

export const enum VectorFieldOptions {
    Embedding = "embedding",
    ImageEmbedding = "imageEmbedding",
    Both = "both"
}

export type ChatAppRequestOverrides = {
    retrieval_mode?: RetrievalMode;
    semantic_ranker?: boolean;
    semantic_captions?: boolean;
    exclude_category?: string;
    top?: number;
    temperature?: number;
    prompt_template?: string;
    prompt_template_prefix?: string;
    prompt_template_suffix?: string;
    suggest_followup_questions?: boolean;
    use_oid_security_filter?: boolean;
    use_groups_security_filter?: boolean;
    use_gpt4v?: boolean;
    gpt4v_input?: GPT4VInput;
    vector_fields: VectorFieldOptions[];
    selected_domain?: string;
    enabled_servers: string[];
    user_id: string;
};

export type ResponseMessage = {
    content: string;
    role: string;
};

export type Thoughts = {
    title: string;
    description: any; // It can be any output from the api
    props?: { [key: string]: string };
};

export type ResponseContext = {
    data_points: { text: string[] };
    followup_questions: string[] | null;
    thoughts: Thoughts[];
};

export type ResponseChoice = {
    index: number;
    message: ResponseMessage;
    context: ResponseContext;
    session_state: any;
    gm_verified?: boolean;
    original_question?: string;
    verified_questions?: VerifiedQuestion[];
};

export type ChatAppResponseOrError = {
    choices?: ResponseChoice[];
    error?: string;
};

export type ChatAppResponse = {
    choices: ResponseChoice[];
    chat_id: string;
};

export type ChatAppRequestContext = {
    overrides?: ChatAppRequestOverrides;
    chat_session_id?: string;
};

export type ChatAppRequest = {
    messages: ResponseMessage[];
    context?: ChatAppRequestContext;
    stream?: boolean;
    session_state: any;
};

export type Config = {
    showGPT4VOptions: boolean;
};

export type Feedback = {
    is_harm: boolean;
    harm_reason: string;
    correct_answer: string;
    procedure_documents: string[];
    additional: string;
};

export type LikeDislikeRequest = {
    chat_id: string;
    is_like: boolean;
};

export type FeedbackRequest = {
    feedback: Feedback;
    chat_id: string;
};

export type Chat = {
    chat_id: string;
    question: string;
    generated_query: string;
    answer: string;
    is_liked: boolean;
    is_harm: boolean;
    harm_reason: string;
    additional: string;
    correct_answer: string;
    timestamp: string;
    gm_verified?: boolean;
    domain_cat: string;
    domain_id: number;
};

export type ChatsResponse = {
    chats: Chat[];
    totalCount: number;
    domainId: number;
};

export type UploadedDocs = {
    blob_container_id: string;
    file_name: string;
    uploaded_by: string;
    uploaded_dt: string;
    domain_name: string;
}

export type UploadedDocsResponse = {
    uploaded_docs: UploadedDocs[];
}

export type DomainOption = {
    domain_id: string;
    domain_name: string;
    active_status: string;
};

export type DomainListResponse = {
    domains: DomainOption[];
};

export type NewVerifiedQuestion = {
    question: string;
    answer: string;
    gm_verified: boolean;
    domain_name: string;
};

export type HtmlParsedAnswer = {
    answerHtml: string;
    citations: string[];
};

export type VerifiedQuestion = {
    question: string;
    answer: string;
    similarity_score: number;
    htmlParsedAnswer: HtmlParsedAnswer;
};

export type SimilarQuestion = {
    verified_questions: VerifiedQuestion[];
};

export type SimilarQuestionOrError = {
    similar_questions?: SimilarQuestion[];
    error?: string;
};
